import { Component, OnInit } from '@angular/core';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { Role } from './../../../interfaces/user';
import { Publication } from './../../../interfaces/publication';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { PublicationService } from '../../../services/publication.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'api-key-list',
	templateUrl: './api-key-list.component.html',
	styleUrls: ['./api-key-list.component.scss'],
	providers: [BbTableService]
})

export class ApiKeyListComponent extends AbstractListComponent implements OnInit {

	filterConfig: BbFilterConfiguration;
	hasExternalUsers: boolean;
	currentPublicationId: string;
	currentPublicationLabel: string;
	rolesData: any;
	putRight = false;

	constructor(
		protected publicationService: PublicationService,
		protected bbTableService: BbTableService
	) {

		super(bbTableService);

		this.currentPublicationId = '';
		this.currentPublicationLabel = '';
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);

		this.listConfiguration = {
			name: 'apikey',
			basePath: '/publication/api-keys/'
		};

		this.filterConfig = {
			search: true
		};
	}

	ngOnInit() {

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			this.currentPublicationId = publication.id;
			this.currentPublicationLabel = publication.label || publication.name;
		}));

		this.subscriptions.add(this.publicationService.getRoles().subscribe((roles: Role[]) => {
			if (roles && roles.length) {
				this.rolesData = {};
				roles.forEach((role) => {
					this.rolesData['role' + role.id] = role.label || role.name;
				});
			}
		}));

		super.ngOnInit();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (
			row && row.data && row.data.id
		) {
			this.router.navigate([this.listConfiguration.basePath, row.data.id]);
		}

	}

	deleteSingle(apikey: any) {
		const dialogContents = this.translate.instant('DELETE_ENTITY_CONFIRM', {
			entity: this.translate.instant('API_KEY').toLowerCase()
		});

		super.deleteSingle(apikey, dialogContents);
	}

	showData(id: number) {
		const url = this.locationService.server + '/sapi/apikey/' + id + '/?sesstoken=' + this.sapiService.getSessionToken();
		const anchor = document.createElement('A');
		anchor.setAttribute('href', url);
		anchor.setAttribute('target', '_blank');

		const evt = document.createEvent('MouseEvents');
		evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		anchor.dispatchEvent(evt);
	}
}
